import { selectIsBossOrSalesBossLevel } from 'core/userContext';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const NAV_BAR_HEIGHT = 64;
export const BOSS_ANNOUNCEMENT_HEIGHT = 51;

export const useNavBarHeight = () => {
  const isBoss = useSelector(selectIsBossOrSalesBossLevel);

  const navBarHeight = useMemo(
    () => (isBoss ? BOSS_ANNOUNCEMENT_HEIGHT + NAV_BAR_HEIGHT : NAV_BAR_HEIGHT),
    [isBoss],
  );

  return navBarHeight;
};
